module.exports = __webpack_public_path__ + "static/media/icon-flash.b7650cd4.svg";